import { Badge } from '@bambi/component-library/src/components/Badge/Badge';
import { upperFirst } from 'lodash-es';


export function SkillBadge({ skill }: { skill: string }): JSX.Element {
  const formattedSkill = upperFirst(skill);
  return <Badge label={formattedSkill} color="blue" />;
}
